import { render, staticRenderFns } from "./ResponsiblePersonList.vue?vue&type=template&id=4822fa9e"
import script from "./ResponsiblePersonList.vue?vue&type=script&lang=js"
export * from "./ResponsiblePersonList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports